import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { useSnackbar } from "notistack";
import { TextField, Icon } from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import SendIcon from "@material-ui/icons/Send";
import { Button } from "../../components/ui/forms/Button";
import LogoLogin from "../../assets/LogoLogin";
import { UserContext } from "../../contexts/UserContext";
import { Copyright } from "./Copyright";
import Spinner from "../../components/ui/Spinner";

function ResetPassword() {
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);

  const { pathname } = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const { resetPassword } = useContext(UserContext);
  const navigate = useNavigate();

  const { handleSubmit, handleChange, handleBlur, values, touched, errors } =
    useFormik({
      initialValues: {
        password: "",
        confirmPassword: "",
      },
      validationSchema: Yup.object({
        password: Yup.string()
          .required(
            <text style={{ color: "yellow" }}>
              Please enter a password 8 characters or longer, with at least one
              uppercase, one lowercase letter, a Number and a Special Character.
            </text>
          )

          .matches(
            /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[$&+=?@#.^*()%!-])/,

            "Password must contact at least a Captial Letter, a Lowercase Letter, a Number and a Special Character"
          ),
        confirmPassword: Yup.string()
          .oneOf([Yup.ref("password"), null])
          .required("Required"),
      }),
      onSubmit: async (values) => {
        setLoading(true);

        let paths = pathname.split("/");
        let resetToken = paths[2];
        console.log(resetToken);

        if (values.password === values.confirmPassword) {
          await resetPassword(values.password, resetToken);
          setTimeout(() => setRedirect(true), 1000);
          loadScreen();
        } else {
          enqueueSnackbar(`Passwords don't match`, {
            variant: "error",
            autoHideDuration: 6000,
            style: { fontSize: "15px" },
          });
        }

        setLoading(false);
      },
    });

  const loadScreen = () => {
    navigate("/login", { replace: true });
  };

  //http://localhost:3000/reset/f26ffb283dadd8289da4ad3dae6949a678cb79ee

  useEffect(() => {
    console.log(pathname);
    // if (id === undefined) {
    //   navigate("/login", { replace: true });
    // }
  }, []);

  return redirect ? (
    loadScreen()
  ) : (
    <Container>
      <Box>
        <LogoLogin />
        <form onSubmit={handleSubmit}>
          {loading ? (
            <Spinner colour="secondary" />
          ) : (
            <>
              <TextField
                type="password"
                name="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
                helperText={
                  errors.password && touched.password && errors.password
                }
                label="New Password"
                size="medium"
                required
              />
              <TextField
                type="password"
                name="confirmPassword"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.confirmPassword}
                helperText={
                  errors.confirmPassword &&
                  touched.confirmPassword &&
                  errors.confirmPassword
                }
                label="Confirm Password"
                size="medium"
                required
              />

              <FormButtons>
                <Button
                  type="submit"
                  colour="secondary"
                  startIcon={
                    <Icon icon={<SendIcon />} className="margin-icon" />
                  }
                >
                  Reset Password
                </Button>
              </FormButtons>
            </>
          )}
        </form>
        <Copyright />
      </Box>
    </Container>
  );
}
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 320px;
  .logo {
    max-width: 180px;
    margin-bottom: 40px;
    margin-top: -80px;
  }
`;

const FormButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0 80px 0;
`;

export default ResetPassword;
